import _ from 'lodash';

/**
 * 
 * @param {object} a
 * @param {object} b
 * @param {string} orderBy table field name
 * @return {number}
 */
export const descendingComparator = (a, b, orderBy) => {
  // const type = getFieldType(orderBy);
  let numA = a[orderBy];
  let numB = b[orderBy];

  // if(type === 'number') {
  //   numA = +numA;
  //   numB = +numB;
  // }

  if (+numB < +numA) {
    return -1;
  }
  if (+numB > +numA) {
    return 1;
  }

  // if (b[orderBy] < a[orderBy]) {
  //   return -1;
  // }
  // if (b[orderBy] > a[orderBy]) {
  //   return 1;
  // }
  return 0;
}

/**
 * 
 * @param {string} order 
 * @param {string} orderBy table field name
 * @return {func}
 */
export const getComparator = (order, orderBy) => {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 * Sort data in array, cross-browser compatibilit to IE11.
 * @param {array} array 
 * @param {func} comparator 
 * @return {array} 
 */
export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);

    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}